import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import BatchIDGenerator from './BatchIDGenerator';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import './BatchID.scss';

function TabPanel(props: {
  children?: React.ReactNode;
  value: number;
  index: number;
  [key: string]: unknown;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

export default function BatchID() {
  const [value, setValue] = React.useState(0);

  return (
    <div className="bid-container" id="batch-id-container">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          value={value}
          onChange={(_e, v) => setValue(v)}
          TabIndicatorProps={{ style: { backgroundColor: 'var(--color-primary)' } }}
          id="batch-id-tabs"
          aria-label="Batch ID navigation"
          sx={{
            minHeight: 36,
          }}
        >
          <Tab
            icon={<AutoAwesomeIcon fontSize="small" />}
            iconPosition="start"
            label="Generate"
            className={value === 0 ? 'bid-tab-selected' : 'bid-tab-unselected'}
            sx={{ minHeight: 36, py: 0.25, px: 1.5, fontSize: 13 }}
            id="batch-id-generate-tab"
            aria-controls="batch-id-generate-panel"
          />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0} id="batch-id-generate-panel">
        <BatchIDGenerator />
      </TabPanel>
    </div>
  );
}
